import { render, staticRenderFns } from "./messageDetail.vue?vue&type=template&id=1ac06d9a&scoped=true"
import script from "./messageDetail.vue?vue&type=script&lang=js"
export * from "./messageDetail.vue?vue&type=script&lang=js"
import style0 from "./messageDetail.vue?vue&type=style&index=0&id=1ac06d9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac06d9a",
  null
  
)

export default component.exports